import { buildQueryExpression, buildTab } from '@coveo/headless';

export function useTab(headlessEngine, tab) {
  if (headlessEngine && tab?.field && tab?.operator && tab?.values && tab?.id) {
    const messageExpression = buildQueryExpression()
      .addStringField({
        field: tab.field,
        operator: tab.operator,
        values: tab.values
      })
      .toQuerySyntax();

    const tabPerFacet = buildTab(headlessEngine, {
      initialState: { isActive: false },
      options: {
        id: tab.id,
        expression: messageExpression
      }
    });

    return tabPerFacet;
  }
  return null;
}
